import { useAuthStore } from '@/stores/auth.store'
import { PERMISSIONS } from '@/constants/permissions'

export function checkUserPermissions() {
  const authStore = useAuthStore()
  const user = authStore.user

  if (!user) {
    console.log('❌ Aucun utilisateur connecté')
    return
  }

  console.log('👤 Utilisateur connecté:', user.nom, user.prenom)
  console.log('🎭 Rôle:', user.role)
  console.log('👥 Type:', user.userType)
  console.log('🔐 Permissions totales:', user.permissions?.length || 0)

  // Vérifier les permissions spécifiques pour les menus masqués
  const requiredPermissions = {
    'Rémunération': [PERMISSIONS.PAYROLL.READ, PERMISSIONS.PAYROLL.MANAGE_SALARIES],
    'Syndicats': [PERMISSIONS.UNION.READ, PERMISSIONS.UNION.UPDATE],
    'Équipements': [PERMISSIONS.EQUIPMENT.READ, PERMISSIONS.EQUIPMENT.CREATE],
    'Templates Documents': [PERMISSIONS.DOCUMENT_TEMPLATE.READ, PERMISSIONS.DOCUMENT_TEMPLATE.CREATE],
    'Rapports': [PERMISSIONS.REPORTS.READ, PERMISSIONS.REPORTS.EXPORT],
    'Configuration': [PERMISSIONS.SETTINGS.READ, PERMISSIONS.SETTINGS.UPDATE],
    'Utilisateurs': [PERMISSIONS.USER.READ, PERMISSIONS.USER.CREATE, PERMISSIONS.USER.UPDATE]
  }

  console.log('\n🔍 Vérification des permissions pour les menus masqués:')
  console.log('====================================================')

  Object.entries(requiredPermissions).forEach(([menuName, permissions]) => {
    console.log(`\n📋 ${menuName}:`)
    permissions.forEach(permission => {
      const hasPermission = authStore.hasPermission(permission)
      console.log(`  ${hasPermission ? '✅' : '❌'} ${permission}`)
    })
  })

  // Vérifier toutes les permissions de l'utilisateur
  console.log('\n📋 Toutes les permissions de l\'utilisateur:')
  console.log('==========================================')
  if (user.permissions) {
    user.permissions.forEach(permission => {
      console.log(`  ✅ ${permission}`)
    })
  }

  // Vérifier les permissions manquantes
  console.log('\n❌ Permissions manquantes:')
  console.log('=========================')
  const allRequiredPermissions = Object.values(requiredPermissions).flat()
  const missingPermissions = allRequiredPermissions.filter(permission => 
    !authStore.hasPermission(permission)
  )
  
  if (missingPermissions.length === 0) {
    console.log('  Aucune permission manquante!')
  } else {
    missingPermissions.forEach(permission => {
      console.log(`  ❌ ${permission}`)
    })
  }

  return {
    user,
    requiredPermissions,
    missingPermissions
  }
}

// Exposer la fonction globalement pour la console
if (typeof window !== 'undefined') {
  (window as any).checkUserPermissions = checkUserPermissions
}
